﻿$.fn.dxCtrlSignatureEmail = function custom_dxCtrlSignatureEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemailsignature dx-ctrl");
        this.createInstance(new cdxCtrlSignatureEmail(this, option));
    }
    return this;
}

window.cdxCtrlSignatureEmail = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
            case "compte_email_utilisateur":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la signature email pour l'adresse email</div>").appendTo(container)
                break;
            case "utilisateur":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la signature email pour toutes les adresses emails de l'utilisateur</div>").appendTo(container)
                break;
            case "compte_client":
                $("<div class='dx-field-item-label-text' style='font-size:80%;padding-bottom:5px;'>Définir la signature email pour toutes les adresses emails de tous les utilisateurs</div>").appendTo(container)
                break;
        }

        var dxCtrlSignature = $("<div/>").appendTo(container).dxCtrlEmailData({
            bddCtrl: option.bddCtrl,
            value: option.data.data_signature,
            allowCorbeille: option.allowCorbeille,
            allowDuplik: false,
            txtTooltip: option.txtTooltip,
            tooltipModif: "Modifier la signature",
            tooltipSupp: "Supprimer la signature",
            tooltipNew: "Créer une nouvelle signature",
            titlePopupEmail: option.titlePopupEmail,
            rempliTxtLib: function (contentElement) {
                contentElement.empty()
                $("<div style='color:green;font-size:16px;'>" + option.txtTooltip + "</div>").appendTo(contentElement)
                mGetDivSignatureRef().appendTo(contentElement).css("font-size","80%")
                //var txtLib = ""
                //if (value == null || value.length == 0) {
                //    txtLib = "<div style='color:" + theme.toastWarning + ";font-size:16px;'>(aucune signature spécifique pour cette adresse)</div>"
                //    if (option.bddCtrl.utiCourant.data_signature == null || option.bddCtrl.utiCourant.data_signature.length == 0) {
                //        txtLib += "<div style='font-size:90%;'>Vous pouvez définir la signature ici uniquement pour ce mail ou dans le profil utilisateur (dans ce cas, la signature s'appliquera à toutes les adresses sans signature).</div>"
                //    } else {
                //        txtLib += "<div style='font-size:90%;'>La signature qui sera utilisé est celle qui est défini au niveau de la configuration utilisateur (dans le profil utilisateur).</div>"
                //    }
                //} else {
                //    txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>Signature spécifique active pour cette adresse</div>"
                //    txtLib += "<div style='font-size:90%;'>Cette signature est spécifique à cette adresse email.</div>"
                //}
                //contentElement.html(txtLib)
            },
            onValueChanged: function (value) {
                option.data.data_signature = value
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(value)
            }
        }).dxCtrlEmailData("instance")
    }

    function mGetDivSignatureRef() {
        var $Div = null
        if (option.data.data_signature == null || option.data.data_signature.length == 0) {
            switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
                case "compte_email_utilisateur":
                    var utiRef = option.bddCtrl.mGetArray("utilisateur").filter(function (o) { return o.id_utilisateur == option.data.id_utilisateur })[0]
                    if (utiRef.data_signature != null && utiRef.data_signature.length > 0) {
                        $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau de cette adresse email.<br/><i>C'est la signature email de l'utilisateur qui sera utilisée.</i></div>").appendTo(container)
                    } else if (option.bddCtrl.objCptCli.data.data_signature != null && option.bddCtrl.objCptCli.data.data_signature.length > 0) {
                        $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau de cette adresse email, ni de l'utilisateur.<br/><i>C'est la signature email du compte client qui sera utilisée.</i></div>").appendTo(container)
                    } else {
                        $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau de cette adresse email, ni de l'utilisateur, ni du compte client.<br/><i>Aucune signature.</i></i></div>").appendTo(container)
                    }
                    break;
                case "utilisateur":
                    if (option.bddCtrl.objCptCli.data.data_signature != null && option.bddCtrl.objCptCli.data.data_signature.length > 0) {
                        $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau de l'utilisateur.<br/><i>C'est la signature email du compte client qui sera utilisée si l'adresse email n'a pas de signature.</i></div>").appendTo(container)
                    } else {
                        $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau de l'utilisateur, ni du compte client.<br/><i>C'est la signature email de l'adresse email qui sera utilisé si elle existe.</i></i></div>").appendTo(container)
                    }
                    break;
                case "compte_client":
                    $Div = $("<div class='dx-field-item-label-text'>La signature email n'est pas défini au niveau du compte client.<br/><i>C'est la signature email de l'utilisateur ou de l'adresse email qui sera utilisé si elle existe.</i></i></div>").appendTo(container)
                    break;
            }
        } else {
            switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
                case "compte_email_utilisateur":
                    $Div = $("<div class='dx-field-item-label-text'>Signature email pour l'adresse email</div>").appendTo(container)
                    break;
                case "utilisateur":
                    $Div = $("<div class='dx-field-item-label-text'>Signature email pour toutes les adresses emails de l'utilisateur<br/><i>Cette signature sera utilisée si la signature de l'adresse email n'est pas définie</i></div>").appendTo(container)
                    break;
                case "compte_client":
                    $Div = $("<div class='dx-field-item-label-text'>Signature email pour toutes les adresses emails de tous les utilisateurs<br/><i>Cette signature sera utilisée si la signature de l'utilisateur ou la signature de l'adresse email n'est pas définie</i></div>").appendTo(container)
                    break;
            }
        }
        return $Div
    }

    this.element = function () { return container }

    mConstruit();
}